import { Chips, FormField, UIHeading5 } from '@cian/ui-kit';
import React, { useEffect, useState } from 'react';

import { IField } from '../../types/calculator';
import { useBaseField } from '../BaseField';
import { ProgramGuideModal } from '../ProgramGuideModal';
import styles from './styles.css';

export const ChipsField: React.FC<IField> = props => {
  const { source = [], label, disabled, defaultValue } = props;
  const {
    field: { onChange, value },
    fieldState,
  } = useBaseField(props);
  const [isProgramGuideOpen, setIsProgramGuideOpen] = useState(false);
  const withProgramGuide = props.variant === 'withProgramGuide';

  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isError = fieldState.isDirty || fieldState.invalid;

  const options = source.map(option => ({
    value: option.value,
    label: option.label,
    disabled: option.disabled || disabled,
  }));

  return (
    <>
      {withProgramGuide && (
        <div className={styles['label-row']}>
          <span className={styles.label}>{label}</span>
          <button
            type="button"
            className={styles['guide-link']}
            onClick={() => setIsProgramGuideOpen(true)}
            data-testid="program-guide-link"
          >
            <UIHeading5 fontWeight="bold" color="text-main-default">
              Как выбрать?
            </UIHeading5>
          </button>
        </div>
      )}

      <FormField
        label={withProgramGuide ? undefined : label}
        errorMessage={isError ? fieldState.error : undefined}
        required={!!props.validation?.required}
        withoutMargin
      >
        <Chips options={options} value={[value]} onChipClick={value => onChange(value)} />
      </FormField>

      {withProgramGuide && <ProgramGuideModal open={isProgramGuideOpen} onClose={() => setIsProgramGuideOpen(false)} />}
    </>
  );
};

ChipsField.displayName = 'ChipsField';
